// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_e85084d9","link":"rdg_aeb70786","aspectRatio":"rdg_9b258b85","linkContent":"rdg_a7987e0d"};